<template>
  <validation-observer ref="addBOM" v-slot="{ invalid }">
  <div>
    <div>
      <b-form ref="form" :style="{ height: trHeight }" class="repeater-form" @submit.prevent="repeateAgain"
        @change="formChanged()">
        <!-- Row Loop -->
        <b-row class="align-items-center" v-for="(item, index) in items" :id="item.serial" :key="item.serial" ref="form">
          <!-- Item Name -->
          <b-col md="2">
            <b-form-group label="Raw Material / Work In Progress" label-for="materialId">
              <b-form-select v-model="item.id" id="materialId" name="materialId" :options="itemOptions" value-field="id"
                text-field="name" @change="itemChanged(item)" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Status" label-for="BOMstatus">
              <b-form-select v-model="item.BOMstatus" :options="BOMStatusList" @change="callChangeStatus()" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Warehouse" label-for="Warehouse">
               <b-form-select v-model="item.wareHouseId" :options="optionsWarehouse" @change="updateQtyAtHand(item)"/>
            </b-form-group>
          </b-col>
          <!-- Quantity -->
          <b-col md="1">
            <b-form-group label="UOM" label-for="materialUom">
              <b-form-select v-model="item.uom" id="materialUom" name="materialUom" :options="itemUoms" value-field="id"
                text-field="name" disabled class="mr-3" />
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group label="Qty at hand" label-for="materialQty">
              <b-form-input v-model="item.physicalinventory" id="materialQty" name="materialQty" type="number" min="1"
                disabled class="mr-3"/>
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group label="Qty Required" label-for="materialQty">
              <validation-provider name="Qty Required" rules="numeric|min_value:0" v-slot="{ errors }">
              <b-form-input v-model="item.quantity" id="materialQty" name="materialQty" type="number" min="1" max="100"
                placeholder="" @keyup="itemqtyChanged(item)" @input="validateQuantity(item)" />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Profession -->
          <b-col md="2">
            <b-form-group label="Total Cost (Rs)" label-for="materialCost">
              <b-form-input v-model="item.totalCost" id="materialCost" name="materialCost" value="32$" disabled />
            </b-form-group>
          </b-col>
          <!-- Remove Button -->
           <b-col md="1" >
            <b-button :to="getUpdate(item.id)" v-b-tooltip.hover.focus.v-secondary title="View all Warehouses of the Raw Material">
              <div class="d-flex flex-shrink">
                <feather-icon icon="BoxIcon" />
                <span>{{ item.stocklevel }}</span>
              </div>
            </b-button>
           </b-col>
          <b-col md="1">
            <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mr-3"
              @click="removeItem(index)">
              <feather-icon icon="XIcon" /> 
            </b-button>
          </b-col>
          <b-col md="1" class="mb-0 d-flex align-items-center">
            <b-form-checkbox
            :value="item.itemId" @change="AddBOMPO(item)"
            class="mb-0">
          </b-form-checkbox>
          </b-col>
         
          <b-col cols="12">
            <hr />
          </b-col>
        </b-row>
      </b-form>

      <!-- <div :class="isVisible ? 'd-flex justify-content-end' : 'd-none justify-content-end'">
        <b-button variant="primary" class="mt-0 mt-md-2 mr-3" @click="createPurchase()">
          <feather-icon icon="XIcon" class="mr-25" />
          <span>Create PO</span>
        </b-button> 
      </div> -->
    </div>
    
    <div class="d-flex">
      <!-- <b-button variant="primary" class="mt-0 mt-md-2 mr-3" :to="createPurchase(item.id, (item.quantity < item.physicalinventory ? 1 : item.quantity - item.physicalinventory))">
        <feather-icon icon="XIcon" class="mr-25" />
        <span>Create PO</span>
      </b-button> -->
      
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="addItem">
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Add Bill Of Materials</span>
      </b-button>
    </div>
   
  </div>
</validation-observer>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BCard,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BRow,
    vSelect,
    BCol,
    BButton,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    BCard,
  },
  directives: {
    Ripple,
  },

  props: {
    JobCard: {
      type: Object,
      default: () => { },
    },
  },

  computed: {
    ...mapGetters("productModule", {
      product: "productID",
      productLoading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      materials: "rawmaterials",
      materialLoading: "loading",
    }),
    ...mapGetters("productModule", {
      products: "product",
      productsLoading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
    ...mapGetters("itemUomModule", {
      itemUoms: "itemuom",
      uomLoading: "loading",
    }),
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [],
      nextSerial: 2,
      itemOptions: [],
      optionsWarehouse: [],
      selectedBOMItems: [],
      //stocklevel: 0,
      isVisible: false, // Initial state
      previousTotalBomCost: 0,
      BOMStatusList: [
        // { value: null, text: "Select Status" },
        { value: 0, text: "Requested with store" },
        { value: 1, text: "Awaiting delivery from supplier" },
        { value: 2, text: "Received" },
        { value: 3, text: "OnHold" }
      ],
    };
  },

  beforeMount() {
    this.getRawMaterialListAction();
    this.getItemUOMListAction();
    this.getProductListAction();
  },
  async mounted() {
    this.initTrHeight();
    await this.getRawMaterialListAction().then(() => {
      this.materials.map((x) => {
        if (x.defaultUomID) {
          this.itemOptions.push({
            id: x.id,
            name: x.name,
            defaultUomID: x.defaultUomID,
            salesPrice: x.salesPrice,
            purchasePrice: x.purchasePrice,
            //physicalinventory: x.physicalinventory,
          });
        }
      });
    });
   
    await this.getProductListAction().then(() => {
      this.products.map((x) => {
        if (x.type === 2) {
          this.itemOptions.push({
            id: x.id,
            name: x.name,
            defaultUomID: x.defaultUomId,
            salesPrice: x.salesPrice,
            purchasePrice: x.purchasePrice,
            physicalinventory: x.physicalinventory,
          });
        }
      });
    });

    this.itemOptions.sort((a, b) => a.name.localeCompare(b.name));

    if (this.warehouse == undefined || this.warehouse.length == 0)
    await this.getWarehouseListAction();
    this.warehouse.map((v, i) =>
      this.optionsWarehouse.push({
        value: v.id,
        text: `${v.name}`,
      })
    );

    this.optionsWarehouse = fnSortingDropdown(this.optionsWarehouse);


   
    
    await this.getItemUOMListAction();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    ...mapActions("rawmaterialModule", ["getRawMaterialListAction"]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("itemUomModule", ["getItemUOMListAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),

    
    getUpdate(item) {
      // if (!item == null){
        return "/rawmaterials/stockTransaction/" + item;
      // }else{
      //   this.$swal({
      //     title: "Raw Material not selected!",
      //     text: "Please Select the Raw Material from the dropdown.",
      //     icon: "error",
      //     customClass: {
      //       confirmButton: "btn btn-primary",
      //     },
      //     buttonsStyling: false,
      //   });
      //}
    },
    callChangeStatus() {
      this.$emit("status", this.item.status);
    },


  updateQtyAtHand(item) {

    //var rmstock = this.materials.find((rm) => rm.id === item.id);
    // console.log("rmstock:",rmstock);
    //this.stocklevel = rmstock.physicalinventory;

    const selectedWarehouse = this.warehouse.find(
      (wh) => wh.id === item.wareHouseId
    );

    if (!selectedWarehouse) {
      console.error("Selected warehouse not found");
      return;
    }
  
    // Find the item in the warehouse's itemBalance
    const itemInWarehouse = selectedWarehouse.itemBalance.find(
      (ib) => ib.productId === item.id
    );
    //console.log("🚗",itemInWarehouse);
    if (itemInWarehouse) {
      // If item is found, update Qty at hand
      item.physicalinventory = itemInWarehouse.stockLevel;
      if(item.physicalinventory == 0){
        item.totalCost == 0;
      }else{
        item.totalCost = (item.quantity ?? 0) * item.cost;
      }
    } else {
      // If item is not found, show an error message
      item.physicalinventory = 0; // Reset Qty at hand
      // this.$swal({
      //   title: "Item Not Available",
      //   text: `The selected item is not available in the selected warehouse (${selectedWarehouse.name}).`,
      //   icon: "error",
      //   customClass: {
      //     confirmButton: "btn btn-primary",
      //   },
      //   buttonsStyling: false,
      // });
    }
  },

  itemqtyChanged(item){

    item.totalCost = (item.quantity ?? 0) * item.cost;
  },
    // handleCheckboxChange(Id) {
    //   const index = this.selectedBOMItems.findIndex(selectedItem => selectedItem.id === item.id);

    //   if (index === -1) {
    //   // If item not in the list, add it
    //   this.selectedBOMItems.push({ id: item.id, quantity: (item.quantity < item.physicalinventory ? 1 : item.quantity - item.physicalinventory) });
    //   } else {
    //   // If item is already selected, remove it
    //   this.selectedBOMItems.splice(index, 1);
    //   }
    //   console.log(this.selectedBOMItems);
    // },
     AddBOMPO(item){
      console.log("🧿",item);
      const index = this.selectedBOMItems.findIndex(selectedItem => selectedItem.id === item.id);

      if (index === -1) {
          // If item not in the list, add it
          // this.selectedBOMItems.push({ id: item.id, quantity: (item.quantity < item.physicalinventory ? 1 : item.quantity - item.physicalinventory) });
          this.selectedBOMItems.push({ id: item.id, quantity: item.quantity });
        } else {
        // If item is already selected, remove it
        this.selectedBOMItems.splice(index, 1);
      }

      this.$emit('newPO', this.selectedBOMItems);

    },

    async createPurchase() {
      // Map the ids of the selected BOM items and join them with commas
      let isValid = await this.$refs.addBOM.validate();
      if(isValid){
      
      
      const itemIds = this.selectedBOMItems.map(item => `${item.id}_${item.quantity}`).join(',');
      console.log("🚲",itemIds);
      try {
        // Redirect to the add purchase order page with selected item IDs in the path
        //const itemIds = this.selectedItemIds.join(",");

        if(itemIds == "" || itemIds.includes('null_1'))
        {
          this.$swal({
          title: "No items",
          text: "Please select at least 1 item to initiate purchase order",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });

          return;
        }
        // this.$router.push({
        //   name: "purchaseorders-edit",
        //   query: { itemIds: itemIds },
        // });

      const url = this.$router.resolve({
      name: "purchaseorder-add",
      query: { itemIds: itemIds },
    }).href;
    console.log("url", url)
    window.open(url, "_blank");
    
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error navigating to the Purchase Order creation page.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    }
    },
    addItem() {
      let item = {
        serial: this.nextSerial,
        id: null,
        rawMaterial: null,
        uom: null,
        quantity: 1,
        cost: null,
        totalCost: 0,
        BOMstatus: 0,
        stocklevel: 0,
        wareHouseId: null,
        physicalinventory: 0,
      };
      this.items.push(item);
      this.nextSerial += 1;
      if (!this.isVisible) {
        this.isVisible = true;
      }
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.form[0].offsetHeight);
      });
    },
    removeItem(index) {

      // Remove the item from selectedBOMItems
      this.selectedBOMItems.splice(index, 1);
  
      // Emit the updated list
      this.$emit('newPO', this.selectedBOMItems);
      
      if (index == 0) {
        this.isVisible = false;
      }
      let removedItemCost = this.items[index].totalCost || 0;
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.form[0].offsetHeight);
      this.formChanged();
      this.JobCard.actualCost -= removedItemCost;
    
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },


    itemChanged(item) {
      //console.log("🎭~ itemtest", item);

      let oldTotalBomCost = this.items.reduce((total, i) => total + (i.totalCost || 0), 0);
      console.log(this.JobCard.actualCost)
      let selectedMaterial = this.itemOptions.filter((obj) => {
        return obj.id === item.id;
      });
      //console.log("🚀 ~ selectedMaterial ~ selectedMaterial:", selectedMaterial)
      if (selectedMaterial.length > 0) {
        item.uom =
          selectedMaterial[0].defaultUomID ?? selectedMaterial[0].defaultUomId;
        item.cost =
          (selectedMaterial[0].purchasePrice ?? 0) == 0
            ? selectedMaterial[0].salePrice ?? 0
            : selectedMaterial[0].purchasePrice ?? 0;
        item.totalCost = (item.quantity ?? 0) * (item.cost ?? 0);

        item.physicalinventory = selectedMaterial[0].physicalinventory ?? 0;
        //console.log("itemuom:", this.itemUoms);
        // Add new material to current product
        let uom = this.itemUoms.filter((obj) => {
          return obj.id === item.uom;
        });
        //console.log("🚀 ~ uom ~ uom:", uom)

        //console.log(this.JobCard.actualCost)

        // Calculate total stock across all warehouses
        let totalStock = 0;
        this.warehouse.forEach(warehouse => {
          const itemInWarehouse = warehouse.itemBalance.find(b => b.productId === item.id);
          console.log("🥘🛺",itemInWarehouse);
          if (itemInWarehouse) {
            totalStock += itemInWarehouse.stockLevel;
          }
        });
        item.stocklevel = totalStock; // 👈 Update THIS ITEM's stock level
        this.$set(this.items, this.items.indexOf(item), item); // Force reactivity

        let newTotalBomCost = this.items.reduce((total, i) => total + (i.totalCost || 0), 0);

        this.JobCard.actualCost += newTotalBomCost - oldTotalBomCost;

        //console.log(this.JobCard.actualCost)
      }
    },
    formChanged() {
      this.$emit("onchange", this.items);
    },
  },

};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
